export default __webpack_public_path__ + "static/media/notification-warning-filled.f18e5872.svg";